import { IElement, isIElementWithFileUri } from "@faro-lotv/ielement-types";
import { Vector3Tuple } from "three";

/**
 * @param element The point cloud element
 * @returns the size of the file behind the element in bytes, if reported
 */
export function getElementFileSize(element: IElement): number | undefined {
  return isIElementWithFileUri(element) && element.fileSize
    ? element.fileSize
    : undefined;
}

/**
 * Estimates the size of the export of a region of a point cloud, assuming the points are evenly distributed
 *
 * @param totalBytes Size of the whole point cloud
 * @param cloudSize Size of the point cloud bounding box
 * @param boxSize Size of the selected region, or undefined if the whole point cloud is selected
 * @returns the estimated size of the region in bytes
 */
export function estimateRegionSizeBytes(
  totalBytes: number,
  cloudSize: Vector3Tuple,
  boxSize?: Vector3Tuple,
): number {
  if (!boxSize) return totalBytes;

  const ratio = cloudSize.reduce(
    (acc, cloudExtent, axis) =>
      cloudExtent > 0
        ? acc * Math.min(1, Math.max(0, boxSize[axis]) / cloudExtent)
        : acc,
    1,
  );
  return Math.round(totalBytes * ratio);
}
